import React, { useState, useEffect } from 'react';
import { Input, Divider, Space, Form, Select, Spin } from 'antd';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton'
import Pagination from '../../../components/global/pagination/Pagination';
import columns from '../../../columns/cashDeposit/usdConversion/columns';
import { AllCurrency, AllCurrencySync, UpdatUpdateCurrencyApi } from '../../../api/request/cashDeposit/usdConversion';
import moment from 'moment/moment';
import toast from 'react-hot-toast';
import LoadableButton from '../../../components/buttons/LoadableButton';

function UsdConversion() {

    const [form] = Form.useForm();

    const [usdValue, setUsdValue] = useState('1');
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [currencyid, setCurrencyid] = useState()
    const [pkrTotalRecord, setPkrTotalRecord] = useState(0);
    const [aedTotalRecord, setAedTotalRecord] = useState(0);
    const [pkrData, setPkrData] = useState([]);
    const [aedData, setAedData] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState('PKR');

    const pkrColumn = {
        title: "PKR/USD",
        dataIndex: "oldRate",
    };
    const aedColumn = {
        title: "AED/USD",
        dataIndex: "oldRate",
    };


    const fetchCurrencyData = async (filterText) => {
        let params = {
            PageNumber: page,
            PageSize: pageSize,
            FilterText: filterText,
        };
        const { data } = await AllCurrency(new URLSearchParams(params).toString());
        return data;
    };

    const getAllCurrencyDetails = async () => {
        try {
            setIsLoading(true);

            const [pkrRes, aedRes] = await Promise.all([
                fetchCurrencyData("PKR"),
                fetchCurrencyData("AED"),
            ]);

            if (pkrRes?.success) {
                setPkrData(
                    pkrRes?.data?.map((item) => ({
                        ...item,
                        modifiedDate: item?.modifiedDate
                            ? moment(item?.modifiedDate).format("DD-MM-YYYY, hh:mm A")
                            : "--",
                    }))
                );
                setCurrencyid(pkrRes?.data[0]?.id);
                setPkrTotalRecord(pkrRes?.totalRecords);
            }

            if (aedRes?.success) {
                setAedData(
                    aedRes?.data?.map((item) => ({
                        ...item,
                        modifiedDate: item?.modifiedDate
                            ? moment(item?.modifiedDate).format("DD-MM-YYYY, hh:mm A")
                            : "--",
                    }))
                );
                setAedTotalRecord(aedRes?.totalRecords);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const getAllCurrencySync = async () => {
        try {
            const payload = {
                BaseCurrency: "USD",
                TargetCurrency: "INR",
                Amount: 1
            }
            const { data } = await AllCurrencySync(new URLSearchParams(payload).toString());
            if (data?.success) {
                form.setFieldValue('amount', data?.data?.exchangeRate)
            }
        }
        catch (error) { }
    }


    const handleUpdate = async (values) => {
        setIsUpdateLoading(true);
        try {
            const payload = {
                ...values,
                currencyId: currencyid,
            }
            const { data } = await UpdatUpdateCurrencyApi(payload);
            if (data?.success) {
                getAllCurrencyDetails();
                form.resetFields();
                toast.success(data?.message);
            }
            setIsUpdateLoading(false);
        }
        catch (error) { setIsUpdateLoading(false) }
    }

    useEffect(() => {
        getAllCurrencyDetails();
    }, [page, pageSize]);

    return (
        <>
            <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full">
                <Form className='w-full' autoComplete="off" form={form} onFinish={handleUpdate}>
                    <div className="px-4 lg:px-6 flex justify-between items-center">
                        <p className="text-[#2F2B3D] text-title font-semibold">INR / USD</p>
                        <div className='flex items-center'>
                            {/* <button
                                type='button'
                                className="flex items-center bg-primary text-sm text-white font-semibold px-5 py-1 mr-3 rounded-lg themeHover duration-500"
                                onClick={getAllCurrencySync}
                            >
                                <svg width="14" height="14" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                                    <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" />
                                </svg>
                            </button> */}
                            <LoadableButton
                                type='submit'
                                className="flex items-center bg-primary text-sm text-white font-semibold px-6 py-2 rounded-lg themeHover duration-500"
                                lable='Update'
                                loadingLable='Updating'
                                isLoading={isUpdateLoading}
                                disabled={isUpdateLoading}
                            />
                        </div>
                    </div>
                    <Divider />
                    <div className='px-4 lg:px-6 mb-7'>
                        <div className="grid sm:grid-cols-4 lg:grid-cols-4 gap-5">
                            <div className='ant-select-selector-white'>
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">Currency type</label>
                                <Form.Item name="currencyType" rules={[{ required: true, message: 'Please currency type.' }]}>
                                    <Select size='large' placeholder='Select currency type' className='w-full mt-1 '
                                        options={[{ value: 2, label: 'PKR' }, { value: 1, label: 'AED' }]}
                                        onChange={(value, option) => setSelectedCurrency(option.label)}
                                    />
                                </Form.Item>
                            </div>
                            <div className="input-white">
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">USD</label>
                                <Input disabled defaultValue={usdValue} className="mt-1 w-full ps-4 py-2" prefix={<span>$</span>} />
                            </div>
                            <div className="input-white" >
                                <label className="text-base text-[#2F2B3DCC] font-medium block mb-1">Amount In {selectedCurrency}</label>
                                <Form.Item name="amount" rules={[{ required: true, message: 'Please enter amount' }]}>
                                    <Input type='number' placeholder="Amount" className="mt-1 w-full ps-4 py-2" />
                                </Form.Item>
                            </div>

                        </div>
                    </div>
                </Form>
            </div>
            <div className='grid sm:grid-cols-2 gap-5'>
                <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                    <div className="px-4 lg:px-6 flex flex-col justify-between ">
                        <p className="text-[#2F2B3D] text-title font-semibold">PKR Update History <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${pkrTotalRecord})`}</span></p>
                    </div>
                    <div className="my-6">
                        <TableWithSkeleton columns={[pkrColumn, ...columns]} data={pkrData} loading={isLoading} page={page} pageSize={pageSize} index={true} />
                        <Pagination total={pkrTotalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                    </div>
                </div>
                <div className="border-[2px] border-[var(--theme-light)] rounded-xl pt-4 lg:pt-6 w-full mt-5">
                    <div className="px-4 lg:px-6 flex flex-col justify-between">
                        <p className="text-[#2F2B3D] text-title font-semibold">AED Update History <span className="primary">{isLoading ? (<Spin className="ml-2" size="small" />) : `(${aedTotalRecord})`}</span></p>
                    </div>
                    <div className="my-6">
                        <TableWithSkeleton columns={[aedColumn, ...columns]} data={aedData} loading={isLoading} page={page} pageSize={pageSize} index={true} />
                        <Pagination total={aedTotalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
                    </div>
                </div>
            </div>

        </>
    )
}

export default UsdConversion
